import React from 'react';
import { FormField } from '../../components/FormField';

interface PromotionCriteriaProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromotionCriteria: React.FC<PromotionCriteriaProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  const criteria = [
    { name: 'hasSeaView', label: 'Immeuble avec vue mer' },
    { name: 'hasClearView', label: 'Immeuble avec vue dégagée' },
    { name: 'hasGuardian', label: 'Gardien' },
    { name: 'hasIntercom', label: 'Interphone' },
    { name: 'hasDigicode', label: 'Digicode' },
    { name: 'hasElevator', label: 'Ascenseur' },
    { name: 'hasSeaView2', label: 'Immeuble avec vue mer' },
    { name: 'hasClearView2', label: 'Immeuble avec vue dégagée' },
    { name: 'hasSharedPool', label: 'Piscine commune' },
    { name: 'hasGarden', label: 'Jardin commun ou privé' },
    { name: 'hasTerrace', label: 'Terrasse' },
    { name: 'hasAirConditioning', label: 'Climatisation' },
    { name: 'hasDoubleGlazing', label: 'Double vitrage' },
    { name: 'hasGasHeating', label: 'Chauffage au gaz' },
    { name: 'hasBalcony', label: 'Balcon' },
    { name: 'hasCommercialSpace', label: 'Immeuble avec commerce' },
    { name: 'hasShopsNearby', label: 'Proximité de commerces' },
    { name: 'hasSchoolsNearby', label: 'Proximité d\'écoles et d\'universités' },
  ];

  return (
    <FormField label="Critères">
      <div className="grid grid-cols-2 gap-4">
        {criteria.map(({ name, label }) => (
          <label key={name} className="flex items-center gap-2">
            <input
              type="checkbox"
              name={name}
              checked={property?.[name] ?? formData[name] ?? false}
              onChange={handleInputChange}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </FormField>
  );
};